const domain = window.location.host;
export const isDevSite = domain.startsWith("localhost");
console.log(domain);

export const ApiConfig = {
  api: isDevSite ? "/site02_dev" : "/site02",
};
